export const REF_NAME = 'REGION';
export const REF_PATH = 'region';
export const NAME = 'Region';
